import Instance from '../../../../Axios';

const RemoverTooltipLimpeza = (id) => async (dispatch) => {
  console.log(id);
  await Instance()
    .delete(`/backend/checklist/tooltip/${id}`)
    .then(({ data }) => {
      dispatch({ type: 'DELETE_TOOLTIP_LIMPEZAS', payload: data });
    })
    .catch(({ err }) => console.log(err));
};

export default RemoverTooltipLimpeza;
